import styled from "styled-components";
import { TableRow } from "@material-ui/core";

export const STWrapper = styled.div`
   {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`;

export const STTableRow = styled(TableRow)`
  && {
    height: 48px;
  }
`;
